<!--
    描述：订阅查看工具
    时间：2020-06-16
    Created by yefan
-->
<template>
    <div class="resources-main w-tabs-layout">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="查询" name="query">
                <span slot="label"><i class="el-icon-search mr5"></i>查询</span>
                <queryTab v-if="activeName === 'query'"></queryTab>
            </el-tab-pane>
            <el-tab-pane label="对比" name="comparison">
                <span slot="label"><i class="el-icon-connection mr5"></i>对比</span>
                <comparisonTab v-if="activeName === 'comparison'"></comparisonTab>
            </el-tab-pane>
            <el-tab-pane label="分析" name="analyze">
                <span slot="label"><i class="el-icon-sunny mr5"></i>分析</span>
                <analyzeTab v-if="activeName === 'analyze'"></analyzeTab>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import queryTab from './query_tab'
    import comparisonTab from './comparison_tab'
    import analyzeTab from './analyze_tab'

    export default {
        name: 'toolss-management',
        components: {queryTab, comparisonTab, analyzeTab},
        data() {
            return {
                activeName: 'query'
            }
        },
        methods: {
            // 切换tab 的事件
            handleClick(tab) {
                let type = null;
                switch (this.activeName) {
                    case 'query':
                        type = 1;
                        break;
                    case 'comparison':
                        type = 2;
                        break;
                    case 'analyze':
                        type = 3;
                        break;
                    default:
                        return
                }

                this.$router.push({
                    query: {
                        type: type
                    }
                })
            },

            // 初始 tabName
            setActiveName() {
                switch (parseInt(this.curType)) {
                    case 1:
                        this.activeName = 'query';
                        break;
                    case 2:
                        this.activeName = 'comparison';
                        break;
                    case 3:
                        this.activeName = 'analyze';
                        break;
                    default:
                        this.activeName = 'query';
                        return
                }
            }
        },
        created() {
            // 设置初始打开 tab 页面
            this.setActiveName()
        },
        computed: {
            // 当前类型 1： 查询  2： 对比  3： 分析
            curType() {
                return this.$route.query.type
            }
        }
    }
</script>

<style lang="less" scoped>
    .resources-main {
        height: 100%;
        background-color: #fff;
        padding: 0 10px;
    }
</style>
